import { render, staticRenderFns } from "./sendConfigForm.vue?vue&type=template&id=59e36274&scoped=true"
import script from "./sendConfigForm.vue?vue&type=script&lang=js"
export * from "./sendConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e36274",
  null
  
)

export default component.exports